import React, { useContext } from 'react';
import { BaseCar2027ContextProps } from './BaseCar2027.types';

const defaultContext = {
  car: {},
  selectedArrangementType: {}
};

export const BaseCar2027Context =
  React.createContext<BaseCar2027ContextProps>(defaultContext);

export const useBaseCar2027Context = () => useContext(BaseCar2027Context);
